/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamLogo
 */
export interface TeamLogo {
    /**
     * 
     * @type {string}
     * @memberof TeamLogo
     */
    baseUrl: string;
    /**
     * 
     * @type {string}
     * @memberof TeamLogo
     */
    fileName: string;
}

/**
 * Check if a given object implements the TeamLogo interface.
 */
export function instanceOfTeamLogo(value: object): value is TeamLogo {
    if (!('baseUrl' in value) || value['baseUrl'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    return true;
}

export function TeamLogoFromJSON(json: any): TeamLogo {
    return TeamLogoFromJSONTyped(json, false);
}

export function TeamLogoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamLogo {
    if (json == null) {
        return json;
    }
    return {
        
        'baseUrl': json['baseUrl'],
        'fileName': json['fileName'],
    };
}

export function TeamLogoToJSON(value?: TeamLogo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'baseUrl': value['baseUrl'],
        'fileName': value['fileName'],
    };
}

